/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type EligibilityCheckState = typeof EligibilityCheckState[keyof typeof EligibilityCheckState];


export const EligibilityCheckState = {
  ActionRequired: 'ActionRequired',
  EncounterCoverageActive: 'EncounterCoverageActive',
  EncounterCoverageInactive: 'EncounterCoverageInactive',
  EncounterCoverageNotFound: 'EncounterCoverageNotFound',
} as const;
